var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisplayPlaceholders)?_c('span',{staticClass:"d-flex flex-row justify-content-end font-roboto"},[_c('PlaceholderBox',{attrs:{"height":'20px',"width":'250px'}})],1):_c('span',[(_vm.quantity > 0 && _vm.text)?_c('span',{staticClass:"font-weight-700 font-size-16 text-primary-orange"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }